import { SecondaryButton } from 'ui_kit_qmd'
import { styles, text } from './Constants'
import './PaymentMethods.scss'
import 'react-calendar/dist/Calendar.css'
import plusIcon from '../../../../../../../../images/common/plusIcon.png'
import { Card } from '../card/Card'

// @ts-expect-error TS7031 -- MIGRATION: not approved, fix when encountered
export const PaymentMethods = ({ addPaymentClick, card, viewCards, methodError }) => (
  <div className='review-book-visit-payment-methods-container'>
    <div className='review-book-visit-payment-methods-header'>
      <label htmlFor='null' className='review-book-visit-payment-methods-title'>
        {text.PAYMENT_METHOD}
      </label>
      {!card && (
        <SecondaryButton
          btnText={text.NEW}
          onPress={addPaymentClick}
          containerStyle={styles.BUTTON_CONTAINER_STYLE}
          image={plusIcon}
          imageStyle={styles.BUTTON_IMAGE_STYLE}
        />
      )}
    </div>
    {/*
     // @ts-expect-error TS2741 -- MIGRATION: not approved, fix when encountered */}
    <Card card={card} viewCards={viewCards} methodError={methodError} />
  </div>
)
